import { Option } from '@inrev/core';

function emptyWipProjectIdentifierToNull(value) {
    if (Option.isNone(value))
        return null;
    const trimmed = value.trim();
    return trimmed === "" ? null : trimmed;
}
function normalizeWipProjectIdentifier(s) {
    if (Option.isNone(s))
        return null;
    const cleaned = s
        .trim()
        .toLowerCase()
        .replace(/\s+/g, " ")
        .replace(/^0+(?=\d)/, "");
    return /[\p{L}\p{N}]/u.test(cleaned) ? cleaned : null;
}
function normalizeWipProjectIdentifiers(identifiers) {
    return {
        name: normalizeWipProjectIdentifier(identifiers.name),
        number: normalizeWipProjectIdentifier(identifiers.number),
    };
}
function wipProjectIdentityKey(identifiers) {
    const normalized = normalizeWipProjectIdentifiers(identifiers);
    return JSON.stringify([normalized.name, normalized.number]);
}
function hasWipProjectIdentity(identifiers) {
    const normalized = normalizeWipProjectIdentifiers(identifiers);
    return Option.isSome(normalized.name) || Option.isSome(normalized.number);
}

export { emptyWipProjectIdentifierToNull, hasWipProjectIdentity, normalizeWipProjectIdentifier, normalizeWipProjectIdentifiers, wipProjectIdentityKey };
